export default __webpack_public_path__ + "static/media/tunnel3.1b4b4daf.jpg";